/**
 * 拷贝文本内容到剪贴板
 * @param input 要拷贝到剪贴板的文本内容
 */
export function copyTextToClipboard(input) {
  var element = document.createElement('textarea');
  var previouslyFocusedElement = document.activeElement;
  element.value = input; // Prevent keyboard from showing on mobile

  element.setAttribute('readonly', '');
  element.style.position = 'absolute';
  element.style.left = '-9999px'; // Prevent zooming on iOS

  element.style.fontSize = '12pt';
  var selection = document.getSelection();
  var originalRange;

  if (selection.rangeCount > 0) {
    originalRange = selection.getRangeAt(0);
  }

  document.body.appendChild(element);
  element.select(); // Explicit selection workaround for iOS

  element.selectionStart = 0;
  element.selectionEnd = input.length;
  var isSuccess = false;

  try {
    isSuccess = document.execCommand('copy');
  } catch (err) {// do nothing
  }

  element.remove();

  if (originalRange) {
    selection.removeAllRanges();
    selection.addRange(originalRange);
  } // Get the focus back on the previously focused element, if any


  if (previouslyFocusedElement) {
    previouslyFocusedElement.focus();
  }

  return isSuccess;
}